import { useNavigate } from 'react-router-dom'
import { Button } from '@app/components';
import { useDispatch } from 'react-redux';
import { setSelectedSubject } from '@app/store/reducers/studentWork';
import { useEffect, useState } from 'react';
import { getStudentById } from '@app/services/student';
import { toast } from 'react-toastify';

interface SelectSubjectProps {
    subjects: any[];
    isLoading: boolean;
    studentId: number;
}

const SelectSubject = ({ subjects, isLoading, studentId }: SelectSubjectProps) => {

    let obj: any = {}
    const dispatch = useDispatch();
    const [isLoadingStudent, setLoadingStudent] = useState(false);
    const [student, setStudent] = useState(obj);
    const navigate = useNavigate()
    const handleSubmit = (subject) => {
	    dispatch(setSelectedSubject(subject))
	}

    useEffect(() => {
        if (!studentId) return;
        getStudentDetailsById()
    },[studentId]);

    const getStudentDetailsById = async () => {
        try {
            setLoadingStudent(true)
            const resp = await getStudentById(studentId);
            if (resp.success === true) {
                setLoadingStudent(false)
                setStudent(resp?.collections)
            } else {
                setLoadingStudent(false)
                toast.error('Unable to load student details. Please try again.')
                setTimeout(() => navigate('/students'), 2000);
            }
        } catch (error: any) {
            setLoadingStudent(false)
            toast.error('Unable to load student details. Please try again.');
            setTimeout(() => navigate('/students'), 2000);
        }
    };

    return (
    <div className="container-fluid">
        <div className="row justify-content-center" style={{marginTop: '15px'}}>
            <div className="col-md-6">
                <div className="text-center" style={{marginBottom: '20px'}}>
                    <h3 style={{fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '8px'}}>
                        Set Student Work
                    </h3>
                    <p style={{fontSize: '1rem', color: '#666', marginBottom: '0'}}>
                        { isLoadingStudent ? <i className="fas fa-sync-alt fa-spin" /> : [student?.first_name, student?.middle_name, student?.last_name].filter(Boolean).join(' ') }
                    </p>
                </div>

                <div className="external-event" style={{backgroundColor: "#ffd316", position: 'relative', zIndex: 'auto', left: '0px', top: '0px', width: '200px', fontWeight: 400, cursor:'default'}}>
                    Select Subject to Set Work
                </div>
                <div className="card" style={{boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                    <div className="card-body" style={{backgroundColor: '#f9f1cc', padding: '25px'}}>
                        <div className="overlay-wrapper">
                            <div className="overlay" style={{flexDirection: 'column', display: isLoading ? 'flex' : 'none'}}>
                                <i className="fas fa-3x fa-sync-alt fa-spin" />
                                <div className="text-bold pt-2">Loading...</div>
                            </div>
                            <div className="row">
                                {subjects.length > 0 && subjects.map((subject) => (
                                    <div className={subjects.length == 1 ? "col-sm-12" : "col-sm-6"}  key={subject.id}>
                                        <div className='mb-3'>
                                            <Button
                                                type="button"
                                                className='btn-info btn-block'
                                                style={{padding: '12px 20px', fontSize: '15px', fontWeight: 500}}
                                                isLoading={isLoading}
                                                onClick={() => handleSubmit(subject)}
                                            >
                                                { subject.name }
                                            </Button>
                                        </div>
                                    </div>
                                ))}

                                {subjects.length == 0 && (
                                    <div className="col-12 text-center">
                                        <div className="alert alert-warning" style={{display: 'inline-block', marginBottom: '0'}}>
                                            <i className="fas fa-exclamation-triangle mr-2"></i>
                                            The student doesn't have any subjects assigned.
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center" style={{marginTop: '20px', marginBottom: '30px'}}>
                    <Button className="btn btn-default" style={{padding: '8px 30px', fontSize: '15px'}} onClick={() => navigate(-1)}>
                        Cancel
                    </Button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SelectSubject;